import Component from "../../core/Component.js";
import {popItem} from "./item.js";
import {confirmCertNo, requestTwoFactor , requestPassTwoFactor} from "./api.js";
import {TWO_FACTOR_ERR_CD, TWO_FACTOR_TYPE} from "./contants.js";

export const render = (props = {}) => {
    const {authType, eml, clphNo, timeLimit, userId, isPass = false, successCallback = Mutil.noop} = props;

    if(isPass) {
        passFactor(userId, successCallback).then();
        return
    }

    $('body').append(`<div id="twoFactorPopArea"></div>`);
    new TwoFactorPop($('#twoFactorPopArea'), {authType, eml, clphNo, timeLimit, userId, successCallback});
}
const passFactor = async ( userId , successCallback ) => {
    const {ERR_CD = ""} = await requestPassTwoFactor({
        USER_ID : userId,
        DUID: Mutil.getLocal('ONLY_DEVICE_ID')
    });

    if(TWO_FACTOR_ERR_CD.NO_PROBLEM !== ERR_CD) {
        Mutil.mlog(`[passFactor()  오류] 서버 오류가 발생했습니다. [코드 :${ERR_CD}] `);
        Mutil.toast("info", i18next.t(exception.error.processError))
        return;
    }

    if(typeof successCallback !== "function") {
        Mutil.mlog("[passFactor()  오류] successCallback이 함수가 아닙니다.");
        return;
    }

    successCallback();
}
class TwoFactorPop extends Component {

    template() {
        const {authType} = this.$props;
        return popItem({authType});
    }

    setEvent() {
        this.addEvent('mousedown', '.back-area', (e) => {
            if ($(e.target).closest('.auth-popup').length > 0) return;
            this.closePop();
        });
        this.addEvent('click', '.phone', () => this.showCertInput({twoFactorType: 'phone'}));
        this.addEvent('click', '.mail', () => this.showCertInput({twoFactorType: 'mail'}));
        this.addEvent('click', '.web', () => this.showCertInput({twoFactorType: 'web'}));
        this.addEvent('click', '.btn-back', () => this.showAuthSelect());
        this.addEvent('click', '.btn-close', () => this.closePop());
        this.addEvent('click', '#resendAuth', () => this.reSendCert());
        this.addEvent('click', '.confirm-button', () => this.confirmCert());
        this.addEvent('keyup', '#certNo', (e) => this.keydownCertNo(e));
    }

    mounted() {
        $("body").css("overflow-y", "hidden");
        const {authType} = this.$props;
        if (authType === TWO_FACTOR_TYPE.EMAIL_OR_CELLPHONE) return;

        let twoFactorType ="";
        if (ServerChecker.isKsfc) {
	        if (authType === 'web' || authType === 'W') twoFactorType = TWO_FACTOR_TYPE.WEB;
            else if(authType === 'mail') twoFactorType = TWO_FACTOR_TYPE.EMAIL;
            else twoFactorType = TWO_FACTOR_TYPE.CELLPHONE;
        }
        twoFactorType = authType === TWO_FACTOR_TYPE.EMAIL ? 'mail' : 'phone';

        setTimeout(() => this.showCertInput({twoFactorType, isSkipSend: true}), 0);
    }

    closePop = () => {
        $("body").css("overflow-y", "");
        $(this.$target).remove();
    }

    keydownCertNo = (e) => {
        if (Mutil.isKey(e, "ENTER")) {
            this.confirmCert().then();
            return;
        }

        const certNo = $(e.target).val();
        const $step2 = $(this.$target).find('.auth-popup.step2');
        const $confirm = $step2.find('.confirm-button');
        const isIntegerOnly = (v) => /^\d*$/.test(v);

        if (!isIntegerOnly(certNo)) {
            $step2.find("#noneNumericAuth").css("display", "inline-block");
            return;
        }

        $step2.find("#noneNumericAuth").css("display", "none");
        if (certNo.length === 6) {
            $confirm.addClass('on');
        } else {
            $confirm.removeClass('on');
        }
    }

    confirmCert = async () => {
        const $confirm = $(this.$target).find('.confirm-button');
        if (!$confirm.hasClass('on')) return;

        const {timeLimit = '3' , successCallback = Mutil.noop } = this.$props;
        const {RSLT_CD = '', ERR_MSG} = await confirmCertNo({
            USER_ID: this.getUserId(),
            DUID: Mutil.getLocal('ONLY_DEVICE_ID'),
            AUTH_NO: this.getCertNo(),
            AUTH_TIME_MM: timeLimit,
            OTP_TR_ID: Often.getCookie("OTP_TR_ID"),
            CHALLENGE: Often.getCookie("CHALLENGE"),
            AUTH_TYPE: this.AUTH_TYPE,
        });

        if ("9203" === RSLT_CD) {
            Mutil.toast('error', ERR_MSG);
            return;
        }

        if (TWO_FACTOR_ERR_CD.NO_PROBLEM !== RSLT_CD) {
            const $step2 = $(this.$target).find('.auth-popup.step2');
            const isExpired = $step2.find("#timeoutAuth").is(":visible");
            $step2.find("#unValidAuth").css("display", isExpired ? "none" : "inline-block");
            $step2.find("#resendAuth").css("display", "inline-block");
            return;
        }

        if (typeof successCallback !== "function") {
            Mutil.mlog("[TwoFactorPop.confirmCert() 오류] successCallback이 함수가 아닙니다.");
            $('#normalLoginButton').trigger('click');
            return;
        }

        successCallback();
    }

    showAuthSelect = () => {
        $(this.$target).find('.auth-popup.step1').show();
        $(this.$target).find('.auth-popup.step2').hide();
    }

    showCertInput = async (props) => {
        const {twoFactorType, isSkipSend} = props;
        const {eml, clphNo, web} = this.$props;
        const {secretEml, secretClphNo} = this.convertSecretData({eml, clphNo});

        if(ServerChecker.isKsfc){
	        if (twoFactorType === 'web' || twoFactorType === 'W') this.AUTH_TYPE = TWO_FACTOR_TYPE.WEB;
            else if(twoFactorType === 'mail') this.AUTH_TYPE = TWO_FACTOR_TYPE.EMAIL;
            else this.AUTH_TYPE = TWO_FACTOR_TYPE.CELLPHONE;
        } else {
            this.AUTH_TYPE = twoFactorType === 'mail' ? TWO_FACTOR_TYPE.EMAIL : TWO_FACTOR_TYPE.CELLPHONE;
            if (twoFactorType === 'phone' && secretClphNo === '') {
                Mutil.toast("error", `유효하지 않은 핸드폰 번호입니다!`);
                return;
            }
        }

        const secretLabel = twoFactorType === 'mail' ? secretEml : secretClphNo;
        const $step2 = $(this.$target).find('.auth-popup.step2');
        let sendVerifiCationCommnet = i18next.t(main.alert.sendVerificationCode, {val: secretLabel, count: 6});
        if (!isSkipSend) {
            //이미 LOGIN_R003에서 인증번호를 보냄
            await this.sendCert();
        }
        if (ServerChecker.isKsfc) {
            if (!KsfcConfig.allowedUser()) await this.sendCert();
            const otpValue = Often.null2Void(Often.getCookie("OTP_VALUE"), "");
            if (otpValue) {
                sendVerifiCationCommnet = `
                    <div>
                        <span>인증번호를 입력해 주시기 바랍니다.</span>
                        <p style="font-size: 0.9em;font-weight:bold;">인증번호 : <span id="otpValue">${otpValue}</span></p>
                    </div>`;
            } else {
                sendVerifiCationCommnet = `
                    <div>
                        <span>인증번호를 입력해 주시기 바랍니다.</span>
                    </div>`;
            }
        } //다국어로 처리 필요
        $step2.find('.popup-cont').html(sendVerifiCationCommnet);
        $step2.find('#otpValue').click((e) => {
            const otpText = $step2.find('#otpValue').text();
            window
                .navigator
                .clipboard
                .writeText(otpText)
                .then(() => {
                    Often.toast('success', '복사되었습니다.');
                })
                .catch((err) => {
                    Often.toast('error', '복사 실패');
                });
        })
        this.countingTimer();
        $(this.$target).find('.auth-popup.step1').hide();
        $step2.show();
        $step2.find('input').focus();
    }

    getCertNo = () => {
        return $.trim($('#certNo').val());
    }

    getUserId = () => {
        const {userId = ''} = this.$props;
        return $.trim(Mutil.n2v(userId, $('#userId').val()));
    }

    reSendCert = async () => {
        this.countingTimer();
        const $step2 = $(this.$target).find('.auth-popup.step2');
        $step2.find("#timeoutAuth, #resendAuth").css("display", "none");
        $step2.find('input').focus();
        await this.sendCert();
    }

    sendCert = async () => {
        await requestTwoFactor({
            USER_ID: this.getUserId(),
            DUID: Mutil.getLocal('ONLY_DEVICE_ID'),
            DUID_NM: Mutil.getLocal('ONLY_DEVICE_NM'),
            AUTH_TYPE: this.AUTH_TYPE
        });
    }

    countingTimer = () => {
        const {timeLimit = '3'} = this.$props;
        const $step2 = $(this.$target).find('.auth-popup.step2');
        $step2.find("#unValidAuth, #timeoutAuth, #resendAuth").css("display", "none");
        let baseTime = +timeLimit * 60;
        if (Mutil.isServerOn("ALL_TEST")) {
            baseTime = 30;
            Mutil.toast('info', '실제 운영은 3분 타이머가 작동됩니다! (테스트 30초)');
        } else if(ServerChecker.isKsfc){ //기능키 처리가 안됨
            baseTime = timeLimit;
        }
        clearInterval(this.counterTimer);
        this.counterTimer = setInterval(() => {
            baseTime--;
            const min = parseInt(baseTime / 60 + '');
            const sec = ('0' + baseTime % 60).slice(-2);
            $step2.find('.js-auth-counter').text(`${min}:${sec}`);
            if (baseTime > 0) return;
            clearInterval(this.counterTimer);
            $step2.find("#timeoutAuth, #resendAuth").css("display", "inline-block");
            $step2.find("#unValidAuth").css("display", "none");
        }, 1000);
    }

    convertSecretData = (props) => {
        const {eml, clphNo} = props;
        const lastTwoHidden = (val) => val.substring(0, val.length - 2) + "**";
        const convertClphNo = (v) => {
            if (v.length < 8) return ""; //8자리가 넘는가?
            if (v.indexOf("+82") !== 0 && v.indexOf("01") !== 0) return ""; //+82 혹은 01로 시작하는가?
            v = v.replace(/ /gi, "-").replace(/--/g, "-");
            if (v.indexOf("+") === 0) return lastTwoHidden(v.replace(/[^+\-\d]/g, ""));
            return lastTwoHidden(v.replace(/[^0-9]/g, "").replace(/(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/, "$1-$2-$3"));
        }
        const bangIdx = eml.indexOf("@");
        return {
            secretEml: eml.substring(0, bangIdx - 2) + '**' + eml.substring(bangIdx),
            secretClphNo: convertClphNo(clphNo),
        }
    }
}
